import {BaseException} from "@/entity/exception/BaseException";

export class WrongLoginOrPasswordException extends BaseException{
    constructor(){
        super("login error","Неправильно введен логин или пароль");
    }
}